import { AppointmentControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

interface Params {
  appointmentId: string;
  customForms?: string;
  assessments?: string;
  xTENANTID?: string;
}

/**
 *
 * @author [Rajkumar Rathod]
 */
export const useAdditionalFormSend = () =>
  useMutationWithLoading(async (params: Params) =>
    new AppointmentControllerApi(getConfigObject()).resendIntakeForms(
      params.appointmentId,
      params.customForms,
      params.assessments,
      params.xTENANTID
    )
  );
